import gridMixin from '../grid.mixin';
import { mapActions, mapGetters, mapState } from 'vuex';
import { getVisualOverlaySnapTimes } from '../../api/asset';
import { assignDurations, CursorManager } from '../../api/tapi';
import fg from '#/libs/FrameGrid';
import tmBus from '../../api/tmBus';

export default {
  mixins: [gridMixin],

  computed: {
    ...mapState('timemachine', {
      MODE_SCENE_EDIT: (state) => state.MODE.SCENE_EDIT,
      secondhand: (state) => state.secondhand,
    }),
    ...mapGetters('timemachine', ['getBgBeats']),

    bgBeatsTimes() {
      return this.getBgBeats.map((item) => item.time);
    },

    moveObj() {
      return {
        enabled: this.MODE_SCENE_EDIT,
        distance2trigger: this.CONST.DND_SENSITIVITY.DEFAULT,
        onMoveStart: this.$_onMoveStart,
        onMove: this.$_onMove,
        onMoveEnd: this.$_onMoveEnd,
      };
    },
  },

  methods: {
    ...mapActions('timemachine', [
      'SET_MODE',
      'SET_DND_ESCORT',
      'SELECT_OVERLAY',
    ]),

    $_onMoveStart(state) {
      this.SET_MODE({ name: 'OVERLAY_DND', value: true });
      this.SET_DND_ESCORT({ name: 'useScrollSensor', value: true });

      const { pipa, overlay } = this.$props;
      state.mousePoint = this.$_mouse2point(state.eDown);
      state.timeShift =
        state.mousePoint.time -
        (pipa.scene.displayStartTime + overlay.displayStartTime);

      const snapTimes = getVisualOverlaySnapTimes(
        pipa,
        overlay,
        this.secondhand
      );
      state.proximityTester = {
        left: this.$_createProximityTester(
          [...snapTimes.left, ...this.bgBeatsTimes],
          this.CONST.AUTOSNAP_PROXIMITY.RESIZE
        ),
        right: this.$_createProximityTester(
          [...snapTimes.right, ...this.bgBeatsTimes],
          this.CONST.AUTOSNAP_PROXIMITY.RESIZE
        ),
      };

      state.initial = assignDurations({}, overlay);
      CursorManager.set('grabbing');
    },

    $_onMove(state) {
      const { pipa, overlay } = this.$props;
      state.mousePoint = this.$_mouse2point(state.eMove, state.mousePoint);
      let curStartTime = fg.trunc(state.mousePoint.time - state.timeShift);
      curStartTime = _.constrain(
        pipa.scene.displayStartTime,
        curStartTime,
        pipa.scene.displayEndTime
      );

      const snapTime = {
        left: state.proximityTester.left.find(curStartTime),
        right: state.proximityTester.right.find(
          curStartTime + state.initial.displayDuration
        ),
      };
      if (null !== snapTime.left) {
        curStartTime = snapTime.left;
      } else if (null !== snapTime.right) {
        curStartTime = fg.trunc(snapTime.right - state.initial.displayDuration);
      }

      pipa.delete(overlay.guid);
      const canFit = pipa.canFit({
        overlay,
        absoluteTime: curStartTime,
      });
      if (canFit) {
        pipa.insert({
          overlay,
          absoluteTime: curStartTime,
          desiredDuration: state.initial.displayDuration,
          isNew: false,
        });
      } else {
        pipa.insert({
          overlay,
          absoluteTime: pipa.toAbsolute(overlay.displayStartTime),
          desiredDuration: state.initial.displayDuration,
          isNew: false,
        });
      }

      tmBus.$emit('callbackSceneUpdate', {
        e: state.eMove,
        scene: this.$props.pipa.scene,
        reflectUsage: false,
      });
    },

    $_onMoveEnd(state) {
      CursorManager.restore();

      if (state.canceled) {
        assignDurations(this.$props.overlay, state.initial);
      }

      this.SELECT_OVERLAY({ overlay: this.$props.overlay });
      this.SET_DND_ESCORT({ name: 'useScrollSensor', value: false });
      this.SET_MODE({ name: 'OVERLAY_DND', value: false });
    },
  },
};
